import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ContentAssignmentWizardService} from "../_services/content-assignment-wizard.service";
import {AuthenticationService} from "../_services/authentication.service";
import {SecurityGroupPermissions} from "../_models/generatedEnums";
import {OrganizationService} from "../_services/generatedServices";
import {Observable} from "rxjs";
import { map } from 'rxjs/operators';

@Injectable()
export class LMSContentAssignmentWizardGuard implements CanActivate {
  constructor(private router: Router, private wizardService: ContentAssignmentWizardService, private auth: AuthenticationService, private orgService: OrganizationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const orgId = route.paramMap.get('organizationId');

    return this.orgService.getOrganization(orgId).pipe(map(organization => {
        const canAssignContent = this.auth.isSuperUser() ||
          this.auth.hasPermission(organization.id, SecurityGroupPermissions.CanAssignContentToAllEmployees) ||
          this.auth.hasPermission(organization.id, SecurityGroupPermissions.CanAssignContentToMyEmployees);

        if (!canAssignContent) {
          if (this.auth.isOrganizationMember(organization.id)) {
            this.router.navigate(['/organizations', orgId, 'admin', 'unauthorized'], {
              queryParams: { returnUrl: state.url }
            });
          } else {
            this.router.navigate(['/'], {
              queryParams: { returnUrl: state.url }
            });
          }
          return false;
        }

        return true;
      })
    );
  }
}
